import CommonService from '../../services/CommonService'

const PrintPdfComponent = (props) => {
  const { finalSaleDetails, finalSaleDependencies } = props;

  return (
    <>
      <html lang="en">
    <head>
        <meta charset="UTF-8"></meta>
        <style>
            {
                "\
              div.repeat-header {\
                padding-top: 0.2in !important;\
                display: block !important;\
                text-align: center;\
                position: running(repeat-header) !important;\
              }\
              .report-header {\
                  text-align: center;\
                  padding: 5px;\
                  width: 100%;\
                  height: 40px;\
                  table-layout:fixed;\
                  border-collapse: collapse;\
              }\
              .report-heading-left {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  width: 20%;\
              }\
              .report-heading-left figure {\
                  margin: 0;\
                  padding: 0;\
              }\
              .report-heading-center {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: center;\
                  width: 60%;\
                  white-space: normal;\
                  overflow-wrap: break-word;\
              }\
              .report-heading-right {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
                  width: 20%;\
                  white-space: nowrap;\
              }\
              .report-heading-center h1, .report-heading-center p, .report-heading-right p {\
                  margin: 0;\
                  padding: 0;\
              }\
              .report-heading-title {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  min-width: 65%;\
              }\
              .report-heading-date {\
                  font-size: 10px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
              }\
              div.footer {\
                position: running(footer) !important;\
              }\
              #current-page-placeholder::before {\
                content: counter(page);\
              }\
              #total-pages-placeholder::before {\
                content: counter(pages);\
              }\
              @page {\
                  margin-top: 90px;\
                  @top-center {\
                      content: element(repeat-header) !important;\
                  }\
              }\
              @page {\
                  @bottom-right {\
                      content: element(footer) !important;\
                      font-size: 10px;\
                  }\
              }\
              div.repeat-header table {\
                  page-break-inside: avoid;\
              }\
              div.repeat-header tr {\
                  page-break-inside: avoid;\
                  page-break-after: auto\
              }\
              div.repeat-header thead {\
                  display: table-header-group\
              }\
              div.repeat-header tfoot {\
                  display: table-footer-group\
              }\
              div.break-page {\
                  page-break-after: always;\
              }\
              .table a {\
                  color: black;\
                  text-decoration: underline;\
              }\
              .table .tableheader th, .table tbody th {\
                  color: #fff;\
                  background-color: darkblue;\
                  border-color: #454d55;\
                  vertical-align: middle;\
                  font-size: 1.0em;\
              }\
              .v-top {\
                  vertical-align: top !important;\
              }\
              tr {\
                  page-break-inside: avoid\
              }\
              h2.info-subsection, h2.sub-heading {\
                  font-size: 13px;\
                  font-weight: bold;\
                  text-align: left;\
                  vertical-align: bottom;\
              }\
              .invoice-box{\
                max-width: 800px;\
                margin: auto;\
                padding: 20px;\
                border: 1px solid #eee;\
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
                font-size: 13px;\
                line-height: 18px;\
                font-family: Helvetica, Arial, sans-serif;\
                color: #555;\
              }\
              .invoice-box table {\
                width: 100%;\
                line-height: inherit;\
                text-align: left;\
              }\
              .invoice-box table.table-border {\
                  border: 1px solid #eee;\
              }\
              .invoice-box table td {\
                padding: 5px;\
                vertical-align: top;\
              }\
            .border-top {\
                  border-top: 2px solid #eee;\
              }\
              .invoice-box table tr.top table td.title {\
                  font-size: 13px;\
                  line-height: 22px;\
                  color: #333;\
              }\
              .invoice-box table tr.information table td {\
                  padding-bottom: 10px;\
              }\
              .invoice-box table tr.heading td {\
                  border-bottom: 1px solid #ddd;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.sub-heading td {\
                font-weight: bold;\
              }\
              .invoice-box table tr.item td {\
                border-bottom: 1px solid #eee;\
              }\
              .invoice-box table tr.item.last td {\
                  border-bottom: none;\
              }\
              .invoice-box table tr.total {\
                  border-top: 2px solid #eee;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.section-title td {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
              }\
              .invoice-box .information table tr th {\
                 padding-bottom: 10px;\
                 vertical-align: bottom;\
                 text-align: left;\
                 font-weight: normal;\
             }\
              .invoice-box .information table tr td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
             }\
              .information {\
                text-align: left;\
                padding-bottom: 20px;\
             }\
              .invoice-box .information .section-title {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
                padding-bottom: 20px;\
             }\
              .info-subsection {\
                padding-bottom: 10px;\
             }\
              .invoice-box .information table.info-subsection caption {\
                 text-align: left;\
              }\
              .fs-12 {\
                padding-bottom: 10px;\
             }\
              .invoice-box table tr.information table.data-table {\
                border: 1px solid #ddd;\
             }\
              .invoice-box .information table.data-table {\
                border: 1px solid #ddd;\
             }\
              .invoice-box .information table.data-table tr.heading .th-left{\
                text-align: left;\
             }\
              .invoice-box .information table.data-table tr.heading .th-right {\
                text-align: right;\
             }\
              .invoice-box .information table.data-table th {\
                text-align: left;\
             }\
              .invoice-box .information table tr.heading th {\
               border-bottom: 1px solid #ddd;\
               font-weight: bold;\
               vertical-align: bottom;\
               text-align: left;\
             }\
              .invoice-box table tr.information th {\
               padding-bottom: 10px;\
               vertical-align: bottom;\
               text-align: left;\
               font-weight: normal;\
             }\
              .invoice-box table tr.information td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
             }\
              @media only screen and (max-width: 600px) {\
              .invoice-box table tr.top table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              .invoice-box table tr.information table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              }\
            "
            }
        </style>
    </head>
    <body className="pdf-box">
        <div className="invoice-box">
            <div><p className="fs-12"><i>Report of Final Sale Information</i></p></div>
            <section className="information">
                <h1 className="section-title">Issuance</h1>
                <table>
                    <tr><th>Issuer Name:</th><td align="right">{finalSaleDetails.issuerName}</td></tr>
                    <tr><th>Issue Name:</th><td align="right">{finalSaleDetails.issueName}</td></tr>
                    <tr><th>Project Name:</th><td align="right">{finalSaleDetails.projectName}</td></tr>
                    <tr><th>Principal:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.principalSaleAmt)}</td></tr>
                    <tr><th>Original Issue Premium:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.premiumAmt)}</td></tr>
                    <tr><th>Original Premium Discount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.premiumDiscountAmt)}</td></tr>
                    <tr><th>Net Original Issue Premium/Discount:</th><td align="right">{CommonService.currencyFormatter((finalSaleDetails.premiumAmt ? finalSaleDetails.premiumAmt : 0) - (finalSaleDetails.premiumDiscountAmt ? finalSaleDetails.premiumDiscountAmt : 0))}</td></tr>
                    <tr><th>Is any portion of the principal to refund, redeem, paydown, or refinance outstanding debt?</th><td align="right">{finalSaleDetails.refndRedeemPaydnRefinInd !== null ? (finalSaleDetails.refndRedeemPaydnRefinInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                    {(finalSaleDetails.refndRedeemPaydnRefinInd !== null && finalSaleDetails.refndRedeemPaydnRefinInd === 'Y') &&
                    <tr><th>Refunding Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.refndRedeemPaydnRefinAmt)}</td></tr>
                    }
                </table>
                {(finalSaleDetails.refndRedeemPaydnRefinInd !== null && finalSaleDetails.refndRedeemPaydnRefinInd === 'Y') &&
                <table>
                    <tr><th colSpan="2">CDIAC# of the debt to be refunded, redeemed, paid down, or refinanced: </th></tr>
                    <tr>
                        <td colSpan="2">
                            <table className="data-table">
                                <tr className="heading">
                                    <th className="th-left">CDIAC #</th>
                                    <th className="th-left">Amount</th>
                                </tr>
                                {finalSaleDependencies.issueRefundAssocs.length > 0 ? finalSaleDependencies.issueRefundAssocs.map((refundAssoc, i) => {
                                return (
                                <tr key={i}>
                                    <td align="left">{refundAssoc.linkedCdiacNbr}</td>
                                    <td align="left">{CommonService.currencyFormatter(refundAssoc.redeemAmt)}</td>
                                </tr>
                                )
                                }) :
                                <tr><td colspan="2">No data available to disaplay.</td></tr>
                                }
                            </table>
                        </td>
                    </tr>
                </table>
                }
                <table>
                    <tr><th>Issuer certifies that it has complied with Gov. Code section 8855(i) with respect to local debt policies:</th><td align="right">{finalSaleDetails.debtPolicyFlag !== null ? (finalSaleDetails.debtPolicyFlag === 'N' ? 'No' : (finalSaleDetails.debtPolicyFlag === 'Y' ? 'Yes' : 'Not Applicable')) : ''}</td></tr>

                    <tr>
                        <td colSpan="2">
                            <table className="data-table">
                                <tr className="heading">
                                    <th className="th-left">Environmental / Social Impact Type</th>
                                    <th className="th-left">Amount</th>
                                </tr>

                                {finalSaleDependencies.issueSocEnvImpacts.length > 0 ? finalSaleDependencies.issueSocEnvImpacts.map((impact, i) => {
                                return (
                                <tr key={i}>
                                    <td align="left">{impact.envSocImpactDisplayName}</td>
                                    <td align="left">{CommonService.currencyFormatter(impact.envSocialImpactAmt)}</td>
                                </tr>
                                )
                                })
                                :
                                <tr><td colspan="2">No Data available to display.</td></tr>
                                }
                            </table>
                        </td>
                    </tr>

                    <tr><th>Marks-Roos Authority/TRAN Pool Authority:</th><td align="right">{finalSaleDetails.marksRoosAuthorityInd !== null ? (finalSaleDetails.marksRoosAuthorityInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                    <tr><th>Marks-Roos Local Obligor/TRAN Participant:</th><td align="right">{finalSaleDetails.marksRoosLocalObligInd !== null ? (finalSaleDetails.marksRoosLocalObligInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                    <tr><th>Maturity Structure:</th><td align="right">{finalSaleDetails.maturityStructureDesc}</td></tr>
                </table>
                {(finalSaleDetails.marksRoosLocalObligInd !== null && finalSaleDetails.marksRoosLocalObligInd === 'Y') &&
                <table>
                    <tr><td>CDIAC# of the related Authorities: </td></tr>
                    <tr className="heading">
                        <th>CDIAC #</th>
                    </tr>
                    {finalSaleDependencies.issueMkrAuthAssocs.length > 0 ? finalSaleDependencies.issueMkrAuthAssocs.map((mkrAuthAssoc, i) => {
                    return (
                    <tr key={i}>
                        <td align="left">{mkrAuthAssoc.authCdiacNbr}</td>
                    </tr>
                    )
                    }) :
                    <tr><td>No data available to disaplay.</td></tr>
                    }
                </table>
                }
            </section>

            {/* Dates */}
            <section className="information">
                <h1 className="section-title">Dates</h1>
                <table>
                    <tr><th>Proposed Sale Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.proposedSaleDate)}</td></tr>
                    <tr><th>Actual Sale Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.actualSaleDate)}</td></tr>
                    <tr><th>Settlement Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.settlementDate)}</td></tr>
                    <tr><th>Dated Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.datedDate)}</td></tr>
                    <tr><th>Final Maturity Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.finalMaturityDate)}</td></tr>
                    <tr><th>First Optional Call Date:</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.firstOptionalCallDate)}</td></tr>
                </table>
            </section>

            {/* Issue Authorization */}
            <section className="information">
                <h1 className="section-title">Issuance Authorization</h1>
                {finalSaleDependencies.issueAuthorizations.length > 0 ? finalSaleDependencies.issueAuthorizations.map((auth, i)=> {
                return (
                <table>
                    <tr><td colspan="2"><b>Authorization ({i + 1}): </b></td></tr>

                    <tr><th>Authorization Name:</th><td align="right">{auth.authorizationName}</td></tr>
                    <tr><th>Original Authorized Amount:</th><td align="right">{CommonService.currencyFormatter(auth.originalAuthorizedAmt)}</td></tr>
                    <tr><th>Authorization Date (MM/DD/YYYY):</th><td align="right">{CommonService.dateFormatter(auth.authorizationDate)}</td></tr>
                    <tr><th>Amount Authorization Replenished (By this Issue):</th><td align="right">{CommonService.currencyFormatter(auth.authorityReplenishAmt)}</td></tr>
                    <tr><th>Amount Authorization Reduced (By this Issue):</th><td align="right">{CommonService.currencyFormatter(auth.authorityReducedAmt)}</td></tr>
                    <tr><th>Net Change:</th><td align="right">{CommonService.currencyFormatter(auth.authorityReplenishAmt - auth.authorityReducedAmt)}</td></tr>
                </table>
                )
                }) :
                <div><p className="fs-12">No data available to display.</p></div>
                }
            </section>

            {/* Statutory Authority */}
            <section className="information">
                <h1 className="section-title">Statutory Authority</h1>
                <div>
                    <table>
                        <tr><th colSpan="3">Will a Validation Action be Pursued?</th><td align="right">{finalSaleDetails.validationActionFlag !== null ? (finalSaleDetails.validationActionFlag === 'N' ? 'No' : 'Yes') : ''}</td></tr>
                    </table>
                </div>

                <div>
                    <h2 className="sub-heading">Statutory Authorities</h2>
                    {finalSaleDependencies.issueStatutes.length > 0 ? finalSaleDependencies.issueStatutes.map((statute, i) => {
                    return (
                    <table>
                        <tr><td colspan="2" align="left"><b>Statute ({i + 1}): </b></td></tr>

                        <tr><th>Statute:</th><td>{statute.displayStatuteName}</td></tr>
                        {statute.statuteId === 'OTH' &&
                        <>
                        <tr><th>Statute Code:</th><td>{statute.otherStatuteCode}</td></tr>
                        <tr><th>Statute Section:</th><td>{statute.otherStatuteText}</td></tr>
                        <tr><th>Statute Description:</th><td>{statute.otherStatuteBriefDesc}</td></tr>
                        </>}
                    </table>
                    )
                    }) :
                    <div><p className="fs-12">No data available to display.</p></div>
                    }
                </div>
            </section>

            <section className="information">
                <h1 className="section-title">Credit</h1>
                <table>
                    <tr><th>Credit Enhancement/Guaranty:</th><td align="right">{finalSaleDetails.guaranteeFlagDesc}</td></tr>
                    <tr><th>Enhancement Expiration Date</th><td align="right">{CommonService.dateFormatter(finalSaleDetails.enhancementExpDate)}</td></tr>
                    <tr><th>Credit Rating:</th><td align="right">{finalSaleDetails.creditNotRatedInd !== null ? (finalSaleDetails.creditNotRatedInd === "Y" ? "Not Rated" : "Rated") : ""}</td></tr>
                    <tr><th>Standard & Poor:</th><td align="right">{finalSaleDetails.stdsPoorRate}</td></tr>
                    <tr><th>Fitch:</th><td align="right">{finalSaleDetails.fitchRate}</td></tr>
                    <tr><th>Moody's:</th><td align="right">{finalSaleDetails.moodyRate}</td></tr>
                    <tr><th>Other:</th><td align="right">{finalSaleDetails.otherRate}</td></tr>
                </table>
            </section>

            {/* Financing participants/Costs */}
            <section className="information">
                <h1 className="section-title">Financing Participants/Costs</h1>
                <div>
                    <table>
                        <tr><td colspan="2"><b>Underwriter</b></td></tr>
                        <tr><th>Management Fee:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.mgmtFeeAmt)}</td></tr>
                        <tr><th>Total Takedown Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.totalTakedownAmt)}</td></tr>
                        <tr><th>Underwriter Expense:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.uwExpenseFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => ['UW', 'LUW', 'OUW'].includes(el.roleCode)) &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.map((el, i) => {
                                    if (['OUW', 'LUW', 'OUW'].includes(el.roleCode)) {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td></tr>)
                                    }
                                    return null;
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Bond Counsel:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.bondCounselFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "BC") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts
                                    .filter((el) => el.roleCode === "BC")
                                    .map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Borrower Counsel:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.borrowerCounselFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => ['BRC', 'CBRW'].includes(el.roleCode)) &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['BRC', 'CBRW'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Co-Bond Counsel:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.cobondCounselFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "CB") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['CB'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Credit Enhancement:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.creditEnhancementFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "GR") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['GR'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Disclosure Counsel:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.disclosureCounselFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "DC") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['DC'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Financial/Municipal Advisor:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.financialAdvisorFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => ['FA', 'CFA', 'MA'].includes(el.roleCode)) &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['FA', 'CFA', 'MA'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Lender:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.lenderFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "LE") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['LE'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Placement Agent:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.placementAgencyFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "PA") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['PA'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Purchaser:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.purchaserFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => ['PU', 'CPU'].includes(el.roleCode)) &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['PU', 'CPU'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Credit Rating Agency:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.ratingAgencyFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "CRA") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['CRA'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Trustee/Paying Agent:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.trusteeFeeAmt)}</td></tr>
                        {finalSaleDependencies.issueContacts && finalSaleDependencies.issueContacts.some(el => el.roleCode === "TR") &&
                        <tr>
                            <td colSpan="2">
                                <table className="table-border">
                                    <tr className="heading">
                                        <th>Organization Name</th>
                                        <th>Contact First Name</th>
                                        <th>Contact Last Name</th>
                                        <th>Fee Amount</th>
                                    </tr>
                                    {finalSaleDependencies.issueContacts.filter((el) => ['TR'].includes(el.roleCode)).map((el, i) => {
                                    return (
                                    <tr key={i}><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td><td align="left">{CommonService.currencyFormatter(el.feeAmt)}</td></tr>)
                                    })}
                                </table>
                            </td>
                        </tr>
                        }
                        <tr><th><b>Other Expenses Amount:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.otherExpenseFeeAmt)}</td></tr>
                        <tr><th><b>Total Additional Fees and Expenses:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.totalAdditionalFees)}</td></tr>
                        <tr><th><b>Total Costs of Issuance:</b></th><td>{CommonService.currencyFormatter(finalSaleDetails.totalAdditionalFees + finalSaleDetails.totalUnderwriterFees)}</td></tr>
                    </table>
                </div>
                <div>
                    <h2 className="sub-heading">Other Contacts:</h2>
                    {finalSaleDependencies.issueContacts &&
                    <table className="data-table">
                        <tr className="heading">
                            <th className="th-left">Role</th>
                            <th className="th-left">Organization</th>
                            <th className="th-left">Contact First Name</th>
                            <th className="th-left">Contact Last Name</th>
                        </tr>
                        {finalSaleDependencies.issueContacts.some(el => !(['BC', 'BRC', 'CB', 'DC', 'LE', 'PA', 'PU', 'FA', 'TR', 'GR', 'MA', 'UW', 'LUW', 'OUW', 'CRA'].includes(el.roleCode))) ?
                        finalSaleDependencies.issueContacts.filter((el) => !['BC', 'BRC', 'CB', 'DC', 'LE', 'PA', 'PU', 'FA', 'TR', 'GR', 'MA', 'UW', 'LUW', 'OUW', 'CRA'].includes(el.roleCode)).map((el, i) => {
                        return (
                        <tr key={i}><td align="left">{el.roleCodeDescription}</td><td align="left">{el.organizationName}</td><td align="left">{el.contactFirstName}</td><td align="left">{el.contactLastName}</td></tr>)
                        }) :
                        <tr><td colspan="4">No data available to display.</td></tr>
                        }
                    </table>
                    }
                </div>
            </section>

            <section className="information">
                <h1 className="section-title">Tax Status/Interest</h1>
                <table>
                    <tr><th>Under State Law:</th><td align="right">{finalSaleDetails.stateTaxFlag != null ? finalSaleDetails.stateTaxFlag === "Y" ? "Taxable" : (finalSaleDetails.stateTaxFlag === "N" ? "Tax-Exempt" : "Taxable, Tax-Exempt") : ''}</td></tr>
                    <tr><th>State Taxable Principal Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.stateTaxPrincipalAmt)}</td></tr>
                    <tr><th>State Tax-Exempt Principal Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.stateTaxExemptAmt)}</td></tr>
                    <tr><th>Under Federal Law:</th><td align="right">{finalSaleDetails.federalLawDisplayText}</td></tr>
                    <tr><th>Federal Taxable Principal Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.federalTaxPrincipalAmt)}</td></tr>
                    <tr><th>Federal Tax-exempt (No AMT) Principal Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.federalTaxExemptAmt)}</td></tr>
                    <tr><th>Federal Tax-exempt (AMT) Principal Amount:</th><td align="right">{CommonService.currencyFormatter(finalSaleDetails.altMinTaxAmt)}</td></tr>
                    {finalSaleDetails.nicInterestTypeInd === "Y" ?
                    <tr><th>Net Interest Cost (NIC):</th><td align="right">{finalSaleDetails.nicInterestCostRate}</td></tr> : ""}
                    {finalSaleDetails.ticInterestTypeInd === "Y" ?
                    <tr><th>True Interest Cost (TIC):</th><td align="right">{finalSaleDetails.ticInterestCostRate}</td></tr> : ""}
                    {finalSaleDetails.varInterestTypeInd === "Y" ?
                    <tr><th>Variable:</th><td align="right">{finalSaleDetails.varInterestCostRate}</td></tr> : ""}
                    {finalSaleDetails.otherInterestTypeInd === "Y" ?
                    <tr><th>Other:</th><td align="right">{finalSaleDetails.otherInterestCostRate}</td></tr> : ""}
                    <tr><th>Capital Appreciation Debt:</th><td align="right">{finalSaleDetails.capitalAppreciationInd != null ? (finalSaleDetails.capitalAppreciationInd === "Y" ? "Yes" : "No") : ""}</td></tr>
                </table>
            </section>

            <section className="information">
                <h1 className="section-title">Type of Debt Instrument</h1>
                <p className="fs-12">{finalSaleDetails.debtInstrumentName}</p>
            </section>

            {/* Source of Repayment */}
            <section className="information">
                <h1 className="section-title">Source of Repayment</h1>
                <table>
                    <tr className="sub-heading"><th colspan="2" align="left"><b>Source of Repayment Types:</b></th></tr>
                    {finalSaleDependencies.issueRepaymentSources.length > 0 ?
                    finalSaleDependencies.issueRepaymentSources.map((source, i) => {
                    return (
                    <tr key={i}><td colspan="2" align="left">{source.displayName}{source.repymtSrcCodeValueCode === "OTHS" && (" (" + source.otherText + ")")}</td></tr>
                    )
                    }) :
                    <tr><td colspan="2">No data available to display.</td></tr>
                    }

                    <tr><th>Is debt repayable in non-US currency?</th><td align="right">{finalSaleDetails.debtRepayNonUsCurrFlag ? (finalSaleDetails.debtRepayNonUsCurrFlag === 'N' ? 'No' : (finalSaleDetails.debtRepayNonUsCurrFlag === 'Y' ? 'Yes' : 'Unknown')) : ''}</td></tr>
                    <tr><th>Senior Structure:</th><td align="right">{finalSaleDetails.seniorInd !== null ? (finalSaleDetails.seniorInd === 'Y' ? 'Yes' : 'No') : ''}</td></tr>
                    <tr><th>Subordinate Structure:</th><td align="right">{finalSaleDetails.subordinateInd !== null ? (finalSaleDetails.subordinateInd === 'N' ? 'No' : 'Yes') : ''}</td></tr>

                </table>
            </section>

            {/* Purpose of Financing */}
            <section className="information">
                <h1 className="section-title">Purpose(s) of Financing</h1>
                <table>
                    <tr className="heading">
                        <th>
                            Purpose Name
                        </th>
                        <th>
                            Percentage
                        </th>
                    </tr>
                    {finalSaleDependencies.issueFinancingPurposes.length > 0 ? finalSaleDependencies.issueFinancingPurposes.map((purpose, i) => {
                    return (
                    <tr key={i}>
                        <td align="left">{purpose.financePurposeName}</td>
                        <td align="left">{purpose.financePurposePct}</td>
                    </tr>
                    )
                    })
                    :
                    <tr><td colspan="2">No data available to display.</td></tr>
                    }
                </table>
            </section>

            {/* Type of Sale */}
            <section className="information">
                <h1 className="section-title">Type of Sale</h1>
                <table>
                    <tr><th className="total currency">Type:</th><td align="right">{finalSaleDetails.saleTypeCode && (finalSaleDetails.saleTypeCode === "N" ? "Negotiated" : "Competitive")}</td></tr>
                    <tr><th className="total currency">Is financing a private placement?</th><td align="right">{finalSaleDetails.pvtPlacementFinanceInd && (finalSaleDetails.pvtPlacementFinanceInd === "N" ? "No" : "Yes")}</td></tr>
                    {finalSaleDetails.saleTypeCode && finalSaleDetails.saleTypeCode === "N" &&
                    <tr><th><b>Reason(s) for Negotiated Sale:</b></th><td align="right"></td></tr>
                    }
                    {finalSaleDependencies.issuePrivateSaleReasons.length > 0 ? finalSaleDependencies.issuePrivateSaleReasons.map((source, i) => {
                    return (
                    <tr key={i}><td colspan="2">{source.displayName}<br />{source.reasonOtherText && source.reasonOtherText}</td></tr>)
                    }) :
                    <tr><td colspan="2">No data available to display.</td></tr>
                    }
                </table>
            </section>

            {/* Document Submittal */}
            <section className="information">
                <h1 className="section-title">Document Submittal</h1>
                <table>
                    <tr><th colspan="2">Official Statements/Offering Memorandum:</th><td align="right">{finalSaleDetails.officialStmtRcvdFlag !== null ? (finalSaleDetails.officialStmtRcvdFlag === "E" ? "Enclosed" : "None Prepared") : ""}</td></tr>
                    <tr><th colspan="2">Maturity Schedule:</th><td align="right">{finalSaleDetails.maturityScheduleCode !== null ? (finalSaleDetails.maturityScheduleCode === "A" ? "Attached" : "Included in official Statement") : ""}</td></tr>
                    <tr className="heading">
                        <th>Document Type</th>
                        <th>Document Name</th>
                        <th>File Upload Date</th>
                    </tr>
                    {finalSaleDependencies.issueDocuments.length > 0 ? finalSaleDependencies.issueDocuments.map((document, i) => {
                    return (
                    <tr key={i}>
                        <td align="left">{document.documentDesc}</td>
                        <td align="left">{document.fileName}</td>
                        <td align="left">{CommonService.dateFormatter(document.createDatetime)}</td>
                    </tr>
                    )
                    }) :
                    <tr><td colspan="3">No data available to disaplay.</td></tr>
                    }
                </table>
            </section>

        </div>
    </body>
</html>
    </>
  );
}

export default PrintPdfComponent;